/* eslint-disable no-unused-vars, max-len, indent, react/function-component-definition, react/self-closing-comp, react/prop-types, react/jsx-props-no-spreading */
import React from 'react';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  muiBtn: {
    border: '1px solid #ccc',
    borderRadius: 4,
    fontFamily: 'Helvetica',
    fontSize: 20,
    height: 30,
    lineHeight: '20px',
    minWidth: 30,
    padding: 0,
    width: 30,
    color: 'black',
  },
}));

const MuButton = React.forwardRef((props, ref) => {
  const classes = useStyles();
  const { className, ...other } = props;
  return (
    <Button ref={ref} className={classNames(classes.muiBtn, className)} {...other} />
  );
});

MuButton.displayName = 'MuButton';

const commonStyle = {
  card: {
    margin: '0 0 5px 0',
    // The outlined selects below (Submit, Write Peaks, Write Intensity, Decimal) are
    // compressed to `selectInput.height = 30`, well under MUI's outlined geometry, so
    // their shrunk InputLabel floats to about -9px - outside this box. Without the
    // padding it only rendered because nothing above clipped; a host that bounds the
    // editor with `overflow: hidden` truncates the labels. Reserve the room here so it
    // holds for any host.
    paddingTop: 10,
    border: '1px solid white',
    borderRadius: 4,
  },
  group: {
    display: 'inline-block',
    margin: '0px 0px 0px 10px',
    verticalAlign: 'middle',
  },
  // Submit's group: the auto left margin takes the free space of its flex line, so it
  // sits at the far right however the toolbar wraps.
  groupRightMost: {
    display: 'inline-block',
    margin: '0px 0px 0px auto',
    verticalAlign: 'middle',
  },
  groupRight: {
    display: 'inline-block',
    margin: '0px 0px 0px 10px',
    verticalAlign: 'middle',
  },
  btnHt: {
    backgroundColor: '#2196f3',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#51c6f3',
    },
  },
  iconWp: {
    border: '1px dashed',
    borderRadius: '4px',
  },
  icon: {
    fontSize: 20,
  },
  iconMdi: {
    fontSize: 20,
  },
  txt: {
    fontFamily: 'Helvetica',
    fontSize: 12,
    fontStyle: 'italic',
    fontWeight: 'bold',
  },
  txtLabel: {
    fontFamily: 'Helvetica',
    fontSize: 12,
  },
  txtInput: {
    fontFamily: 'Helvetica',
    fontSize: 12,
    height: 30,
  },
  txtOpt: {
    fontFamily: 'Helvetica',
    fontSize: 12,
  },
  selectLabel: {
    fontFamily: 'Helvetica',
    fontSize: 12,
  },
  selectInput: {
    height: 30,
  },
  txtLabelBottomInput: {
    fontFamily: 'Helvetica',
    backgroundColor: 'white',
    fontSize: 12,
    margin: '22% 0 0 7px',
    padding: '0 10px 0 10px',
    transform: 'scale(0.75)',
  },
  txtLabelTopInput: {
    fontFamily: 'Helvetica',
    backgroundColor: 'white',
    fontSize: 12,
    margin: '-8% 0 0 7px',
    padding: '0 10px 0 10px',
    transform: 'scale(0.75)',
  },
};

const focusStyle = (criteria, cls) => (criteria ? [cls.btnHt] : []);

export { MuButton, commonStyle, focusStyle } // eslint-disable-line
